import React, { useEffect, useRef, useState } from "react";
import doxzonLogo from "../assets/logo/Doxzon LogoNew.svg";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FaBars, FaShoppingCart, FaTimes } from "react-icons/fa";
import { Avatar, Badge, Drawer, Dropdown, Menu, Modal, Tooltip } from "antd";
import { APP_ROUTES } from "../PageRouting/pageRoutes";
import Login from "../Authentication/Login";
import { GiHealing } from "react-icons/gi";
import { MdContactEmergency } from "react-icons/md";
import EmergencyDataView from "./EmergencyDataView";
import { IoIosChatboxes, IoIosNotifications } from "react-icons/io";
import LiveChat from "../Pages/LiveChat";
import { countUnreadMessages } from "../Services/chatService";
import { useDispatch, useSelector } from "react-redux";
import { GETCOUNT } from "../Redux/actions/ChatActions";
import SignUp from "../Authentication/SignUp";
import {
  handleLoginSignUpModal,
  LOGINMODAL,
  SIGNUPMODAL,
} from "../Redux/actions/commonActions";
import { getNotificationCount } from "../Redux/actions/NotificationActions";
import {
  clearLoggedUser,
  deleteDataFromLocal,
} from "../Redux/actions/AuthActions";
import MembershipSlider from "./MembershipSlider";
import { clearSelectedAppt } from "../Redux/actions/appointmentActions";

/* ─────────────────────────────────────────────
   Inline styles for the redesigned side menu
───────────────────────────────────────────── */
const sideMenuStyles = `
  @import url('https://fonts.googleapis.com/css2?family=Nunito:wght@400;600;700;800&display=swap');

  .dox-sidemenu-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0,0,0,0.45);
    z-index: 39;
    backdrop-filter: blur(2px);
    animation: overlayFadeIn 0.25s ease;
  }
  @keyframes overlayFadeIn { from { opacity: 0 } to { opacity: 1 } }

  .dox-sidemenu {
    font-family: 'Nunito', sans-serif;
    position: fixed;
    top: 0;
    left: 0;
    height: 100dvh;
    width: 78vw;
    max-width: 300px;
    background: linear-gradient(160deg, #0d7a84 0%, #0a5f68 40%, #063d45 100%);
    z-index: 40;
    transform: translateX(-100%);
    transition: transform 0.32s cubic-bezier(0.4, 0, 0.2, 1);
    display: flex;
    flex-direction: column;
    overflow: hidden;
    box-shadow: 6px 0 32px rgba(0,0,0,0.35);
  }
  .dox-sidemenu.open {
    transform: translateX(0);
  }

  /* decorative teal glow blob */
  .dox-sidemenu::before {
    content: '';
    position: absolute;
    top: -60px;
    right: -60px;
    width: 180px;
    height: 180px;
    background: radial-gradient(circle, rgba(24,159,170,0.55) 0%, transparent 70%);
    border-radius: 50%;
    pointer-events: none;
  }

  /* header strip */
  .dox-sidemenu-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 14px 18px 12px;
    border-bottom: 1px solid rgba(255,255,255,0.1);
  }
  .dox-sidemenu-logo {
    width: 90px;
  }
  .dox-sidemenu-close {
    background: rgba(255,255,255,0.12);
    border: none;
    border-radius: 50%;
    width: 34px;
    height: 34px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    cursor: pointer;
    transition: background 0.2s;
  }
  .dox-sidemenu-close:hover { background: rgba(255,255,255,0.22); }

  /* user card */
  .dox-sidemenu-usercard {
    margin: 14px 16px 6px;
    background: rgba(255,255,255,0.08);
    border: 1px solid rgba(255,255,255,0.13);
    border-radius: 14px;
    padding: 12px 14px;
    display: flex;
    align-items: center;
    gap: 12px;
  }
  .dox-sidemenu-avatar {
    width: 44px;
    height: 44px;
    border-radius: 50%;
    background: #189FAA;
    border: 2px solid rgba(255,255,255,0.4);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    font-weight: 800;
    color: #fff;
    flex-shrink: 0;
  }
  .dox-sidemenu-username {
    font-size: 15px;
    font-weight: 700;
    color: #fff;
    line-height: 1.2;
  }
  .dox-sidemenu-subtitle {
    font-size: 11px;
    color: rgba(255,255,255,0.6);
    margin-top: 2px;
  }

  /* scroll area */
  .dox-sidemenu-scroll {
    flex: 1;
    overflow-y: auto;
    padding: 8px 0 20px;
    scrollbar-width: none;
  }
  .dox-sidemenu-scroll::-webkit-scrollbar { display: none; }

  /* section label */
  .dox-sidemenu-section-label {
    font-size: 9.5px;
    font-weight: 800;
    letter-spacing: 1.4px;
    color: rgba(255,255,255,0.4);
    text-transform: uppercase;
    padding: 14px 20px 4px;
  }

  /* menu item */
  .dox-sidemenu-item {
    display: flex;
    align-items: center;
    gap: 13px;
    padding: 11px 20px;
    color: rgba(255,255,255,0.88);
    font-size: 13.5px;
    font-weight: 600;
    cursor: pointer;
    border: none;
    background: none;
    width: 100%;
    text-align: left;
    text-decoration: none;
    border-radius: 0;
    transition: background 0.18s, color 0.18s, padding-left 0.18s;
    position: relative;
  }
  .dox-sidemenu-item:hover {
    background: rgba(255,255,255,0.09);
    color: #fff;
    padding-left: 26px;
  }
  .dox-sidemenu-item.active {
    background: rgba(255,255,255,0.13);
    color: #fff;
  }
  .dox-sidemenu-item.active::before {
    content: '';
    position: absolute;
    left: 0;
    top: 20%;
    height: 60%;
    width: 3px;
    background: #5de8f0;
    border-radius: 0 3px 3px 0;
  }
  .dox-sidemenu-item-icon {
    width: 30px;
    height: 30px;
    border-radius: 8px;
    background: rgba(255,255,255,0.1);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 15px;
    flex-shrink: 0;
    transition: background 0.18s;
  }
  .dox-sidemenu-item:hover .dox-sidemenu-item-icon {
    background: rgba(93,232,240,0.2);
  }

  /* submenu */
  .dox-sidemenu-submenu {
    overflow: hidden;
    max-height: 0;
    transition: max-height 0.3s ease;
  }
  .dox-sidemenu-submenu.open {
    max-height: 400px;
  }
  .dox-sidemenu-submenu-item {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 9px 20px 9px 62px;
    color: rgba(255,255,255,0.72);
    font-size: 12.5px;
    font-weight: 600;
    cursor: pointer;
    border: none;
    background: none;
    width: 100%;
    text-align: left;
    transition: color 0.15s, background 0.15s;
  }
  .dox-sidemenu-submenu-item:hover {
    color: #fff;
    background: rgba(255,255,255,0.06);
  }
  .dox-sidemenu-submenu-dot {
    width: 5px;
    height: 5px;
    border-radius: 50%;
    background: rgba(93,232,240,0.7);
    flex-shrink: 0;
  }

  /* chevron */
  .dox-chevron {
    margin-left: auto;
    font-size: 11px;
    color: rgba(255,255,255,0.45);
    transition: transform 0.25s;
  }
  .dox-chevron.open { transform: rotate(180deg); }

  /* divider */
  .dox-sidemenu-divider {
    height: 1px;
    background: rgba(255,255,255,0.08);
    margin: 6px 16px;
  }

  /* logout pill */
  .dox-sidemenu-logout {
    display: flex;
    align-items: center;
    gap: 13px;
    margin: 4px 16px 0;
    padding: 11px 16px;
    background: rgba(255, 80, 80, 0.13);
    border: 1px solid rgba(255,80,80,0.2);
    border-radius: 12px;
    color: #ff8585;
    font-size: 13.5px;
    font-weight: 700;
    cursor: pointer;
    width: calc(100% - 32px);
    text-align: left;
    transition: background 0.2s;
  }
  .dox-sidemenu-logout:hover { background: rgba(255,80,80,0.22); }

  /* footer */
  .dox-sidemenu-footer {
    padding: 12px 16px;
    border-top: 1px solid rgba(255,255,255,0.08);
    display: flex;
    gap: 8px;
  }
  .dox-sidemenu-footer-btn {
    flex: 1;
    padding: 10px;
    border-radius: 10px;
    font-size: 13px;
    font-weight: 700;
    cursor: pointer;
    border: none;
    transition: opacity 0.2s;
  }
  .dox-sidemenu-footer-btn:hover { opacity: 0.85; }
  .dox-footer-login {
    background: #fff;
    color: #0a5f68;
  }
  .dox-footer-signup {
    background: rgba(255,255,255,0.12);
    color: #fff;
    border: 1px solid rgba(255,255,255,0.2) !important;
  }
`;

function Navbar() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [showsideMenuDropdown, setShowsideMenuDropdown] = useState(false);
  const [emgDataModal, setEmgDataModal] = useState(false);
  const [chatOpen, setChatOpen] = useState(false);
  const [medRecordsOpen, setMedRecordsOpen] = useState(false);
  const sideMenudropdownRef = useRef(null);
  const headerdropdownRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();
  const loggedUserJson = localStorage.getItem("patientData");
  const loggedUser = loggedUserJson ? JSON.parse(loggedUserJson) : null;
  const dispatch = useDispatch();
  const { selectedType, regModal, loginModal } = useSelector(
    (state) => state.common,
  );
  const totalnotifyCount = useSelector((state) => state.chatCount.count);
  const notificationCount = useSelector(
    (state) => state.notificationCount.count,
  );
  const { cartData } = useSelector((state) => state.cart);

  useEffect(() => {
    if (!loggedUser) return;
    const onCountChange = (size) => {
      dispatch({ type: GETCOUNT, payload: size });
    };
    const unsubscribe = countUnreadMessages(loggedUser.patientId, onCountChange);
    return () => {
      if (typeof unsubscribe === "function") unsubscribe();
    };
  }, [loggedUser, dispatch]);

  useEffect(() => {
    if (showDropdown) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [showDropdown]);

  useEffect(() => {
    if (location.hash === "#HospitalService") {
      const procedureSection = document.getElementById("HospitalService");
      if (procedureSection) procedureSection.scrollIntoView({ behavior: "smooth" });
    }
  }, [location]);

  const handleClickOutside = (event) => {
    if (headerdropdownRef.current && !headerdropdownRef.current.contains(event.target)) {
      setShowDropdown(false);
    }
  };

  const handleSideMenuSignuUp = () => setShowsideMenuDropdown(!showsideMenuDropdown);
  const handleLoginModal = () => dispatch(handleLoginSignUpModal({ data: true, actionType: LOGINMODAL }));
  const handleLoginModalClose = () => dispatch(handleLoginSignUpModal({ data: false, actionType: LOGINMODAL }));
  const handleSignUpFromLogin = () => {
    dispatch(handleLoginSignUpModal({ data: false, actionType: LOGINMODAL }));
    dispatch(handleLoginSignUpModal({ data: true, actionType: SIGNUPMODAL }));
  };
  const handleReg = () => dispatch(handleLoginSignUpModal({ data: true, actionType: SIGNUPMODAL }));
  const handleRegClose = () => dispatch(handleLoginSignUpModal({ data: false, actionType: SIGNUPMODAL }));
  const toggleMobileMenu = () => setIsMobileMenuOpen(!isMobileMenuOpen);
  const handleRoute = (route) => { navigate(route); setIsMobileMenuOpen(false); };
  const handleLogOut = () => {
    localStorage.clear();
    dispatch(deleteDataFromLocal());
    dispatch(clearLoggedUser(null));
    dispatch(clearSelectedAppt(null));
    handleRoute(APP_ROUTES.LOGIN);
  };
  const handleHSNavigation = () => {
    const currentPath = location.pathname;
    navigate(APP_ROUTES.HEALTHSUMMARY, { state: { patientId: loggedUser.patientId, path: currentPath } });
  };
  const handleEmgDataView = () => setEmgDataModal(true);
  const handleEmgClose = () => setEmgDataModal(false);
  const handleChatOpen = () => setChatOpen(true);
  const handleChatClose = () => setChatOpen(false);

  const menu = (
    <Menu className="w-full">
      <Menu.Item key="1" onClick={() => handleRoute(APP_ROUTES.MYPROFILE)}>My Profile</Menu.Item>
      {!loggedUser?.parentPatientId && (
        <Menu.Item key="2" onClick={() => handleRoute(APP_ROUTES.FAMILYMEMBERS)}>Family Members</Menu.Item>
      )}
      <Menu.Item key="3" onClick={() => handleRoute(APP_ROUTES.MYAPPOINMENTS)}>Appointments</Menu.Item>
      <Menu.SubMenu key="medicalRecords" title="Medical Records">
        <Menu.Item key="4-1" onClick={() => handleRoute(APP_ROUTES.MEDICALHISTORY)}>Medical History</Menu.Item>
        <Menu.Item key="4-2" onClick={() => handleRoute(APP_ROUTES.MYPRESCRIPTION)}>My Prescription</Menu.Item>
        <Menu.Item key="4-3" onClick={() => handleRoute(APP_ROUTES.MYREPORTS)}>My Reports</Menu.Item>
        <Menu.Item key="4-4" onClick={() => handleRoute(APP_ROUTES.MYLABREPORTS)}>Lab Reports</Menu.Item>
        <Menu.Item key="4-5" onClick={() => handleRoute(APP_ROUTES.MYVITALS)}>Vitals</Menu.Item>
      </Menu.SubMenu>
      <Menu.Item key="5" onClick={() => handleRoute(APP_ROUTES.PAYMENTS)}>Payments</Menu.Item>
      <Menu.Item key="11" onClick={() => handleRoute(APP_ROUTES.MEMBERSHIP)}>Membership</Menu.Item>
      <Menu.Item key="9" onClick={() => handleRoute(APP_ROUTES.ORDERHISTORY)}>Order History</Menu.Item>
      <Menu.Item key="6" onClick={() => handleRoute(APP_ROUTES.CONSENT)}>Consent</Menu.Item>
      <Menu.Item key="7" onClick={() => handleRoute(APP_ROUTES.SETTINGS)}>Settings</Menu.Item>
      {loggedUser?.rpmApplicable === "Y" && (
        <Menu.Item key="10" onClick={() => handleRoute(APP_ROUTES.DEVICES)}>Devices</Menu.Item>
      )}
      <Menu.Item key="11b" onClick={() => handleRoute(APP_ROUTES.PROCEDURELIST)}>Procedure List</Menu.Item>
      <Menu.Item key="8" onClick={handleLogOut}>Logout</Menu.Item>
    </Menu>
  );

  useEffect(() => { getNotiCount(); }, []);
  const getNotiCount = async () => {
    try { await dispatch(getNotificationCount()); } catch (e) { console.error(e); }
  };

  /* ── helpers for new side menu items ── */
  const isActive = (route) => location.pathname === route;

  return (
    <div className="w-full bg-[#189FAA] fixed z-50 top-0 py-2 px-5 h-[70px]">
      {/* Inject side-menu styles */}
      <style>{sideMenuStyles}</style>

      <div className="w-full flex justify-between items-center h-full">

        {/* ── LEFT ── */}
        <div className="flex items-center gap-7">
          {/* Hamburger — mobile only */}
          <div className="flex xl:hidden lg:hidden text-white">
            <button onClick={toggleMobileMenu}>
              {isMobileMenuOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
            </button>
          </div>

          {/* Logo */}
          {!loggedUser ? (
            <div className="cursor-pointer" onClick={() => handleRoute(APP_ROUTES.LOGIN)}>
              <img className="w-24 h-24" src={doxzonLogo} alt="Logo" />
            </div>
          ) : (
            <div className="cursor-pointer" onClick={() => handleRoute(APP_ROUTES.HOME)}>
              <img className="w-28 h-28" src={doxzonLogo} alt="Logo" />
            </div>
          )}

          {/* Desktop nav links */}
          <div className="nav hidden lg:flex items-center text-white gap-7">
            <Link to={APP_ROUTES.CONSULTDOCTOR} className={`leading-normal hover:text-[#C1F2F5] no-underline font-inter font-medium xl:text-[17px] lg:text-[14px] cursor-pointer ${location.pathname === APP_ROUTES.CONSULTDOCTOR ? "border-b-4 border-b-white" : ""}`}>
              Consult Doctor
            </Link>
            <div className="flex gap-1 items-center">
              <Link to={APP_ROUTES.MEDICINES} className={`leading-normal hover:text-[#C1F2F5] no-underline font-inter font-medium xl:text-[17px] lg:text-[14px] cursor-pointer ${location.pathname === APP_ROUTES.MEDICINES ? "border-b-4 border-b-white" : ""}`}>
                Medicine
              </Link>
            </div>
            <Link to={APP_ROUTES.LABTESTS} className={`leading-normal hover:text-[#C1F2F5] no-underline font-inter font-medium xl:text-[17px] lg:text-[14px] cursor-pointer ${location.pathname === APP_ROUTES.LABTESTS ? "border-b-4 border-b-white" : ""}`}>
              Lab Tests
            </Link>
            <Link to={APP_ROUTES.HOSPITALSERVICE} className={`leading-normal hover:text-[#C1F2F5] no-underline font-inter font-medium xl:text-[17px] lg:text-[14px] cursor-pointer ${location.pathname === APP_ROUTES.HOSPITALSERVICE ? "border-b-4 border-b-white" : ""}`}>
              Procedure
            </Link>
          </div>
        </div>

        {/* ── RIGHT ── */}
        <div className="flex items-center justify-end">
          <ul className="nav hidden lg:flex items-center font-sans text-white gap-3">
            {!loggedUser && (
              <Link to="/#providers" className="leading-normal hover:text-[#C1F2F5] no-underline text-[17px] cursor-pointer">
                For Providers
              </Link>
            )}
            {!loggedUser && (
              <Link to="/#patients" className="leading-normal hover:text-[#C1F2F5] no-underline text-[17px] cursor-pointer">
                For Patients
              </Link>
            )}
            {!loggedUser && (
              <Link to="/#clinic" className="leading-normal hover:text-[#C1F2F5] no-underline text-[17px] cursor-pointer">
                For Clinic
              </Link>
            )}

            {!loggedUser ? (
              <div className="flex gap-1 items-center">
                <button className="leading-normal hover:text-[#C1F2F5] no-underline text-[17px] cursor-pointer" onClick={handleLoginModal}>
                  Login
                </button>
              </div>
            ) : (
              <div className="flex items-center gap-4">
                <button className="text-sm border rounded text-primaryColor font-semibold px-2 py-1 bg-white" onClick={() => navigate(APP_ROUTES.DIETPLAN)}>
                  Diet
                </button>
                <Tooltip title="Chats" onClick={() => navigate(APP_ROUTES.NOTIFICATION)}>
                  <Badge className="w-6 h-6 relative cursor-pointer">
                    {notificationCount > 0 && (
                      <div className="bg-red-600 rounded-full text-white text-[10px] font-semibold text-center flex justify-center items-center max-w-max min-w-5 w-5 h-5 absolute bottom-[15px] right-[10px]">
                        {notificationCount > 99 ? "99+" : notificationCount}
                      </div>
                    )}
                    <IoIosNotifications className="text-White text-lg" onClick={() => navigate(APP_ROUTES.NOTIFICATION)} />
                  </Badge>
                </Tooltip>
                <Tooltip title="Chats" onClick={handleChatOpen}>
                  <Badge className="w-6 h-6 relative cursor-pointer">
                    {totalnotifyCount > 0 && (
                      <div className="bg-red-600 rounded-full text-white text-[10px] font-semibold text-center flex justify-center items-center max-w-max min-w-5 w-5 h-5 absolute bottom-[15px] left-[10px]">
                        {totalnotifyCount > 99 ? "99+" : totalnotifyCount}
                      </div>
                    )}
                    <button className="w-[inherit] h-[inherit]">
                      <IoIosChatboxes className="text-White text-lg" />
                    </button>
                  </Badge>
                </Tooltip>
                <Tooltip title="Emergency Data">
                  <button onClick={handleEmgDataView}>
                    <MdContactEmergency className="text-White text-lg" />
                  </button>
                </Tooltip>
                <Tooltip title="Health Summary">
                  <button onClick={handleHSNavigation}>
                    <GiHealing className="text-White text-lg" />
                  </button>
                </Tooltip>
                <Dropdown overlay={menu} trigger={["click", "hover"]}>
                  <Avatar className="bg-White text-iconBlue text-lg font-medium cursor-pointer">
                    {loggedUser?.firstName.charAt(0)}
                  </Avatar>
                </Dropdown>
              </div>
            )}
          </ul>

          {/* Chat icon — mobile only */}
          {loggedUser && (
            <div className="flex lg:hidden xl:hidden mr-3">
              <Tooltip title="Chats" onClick={handleChatOpen}>
                <Badge className="w-6 h-6 relative cursor-pointer">
                  {totalnotifyCount > 0 && (
                    <div className="bg-red-600 rounded-full text-white text-[10px] font-semibold text-center flex justify-center items-center max-w-max min-w-5 w-5 h-5 absolute bottom-[15px] left-[10px]">
                      {totalnotifyCount > 99 ? "99+" : totalnotifyCount}
                    </div>
                  )}
                  <button className="w-[inherit] h-[inherit]">
                    <IoIosChatboxes className="text-White text-lg" />
                  </button>
                </Badge>
              </Tooltip>
            </div>
          )}

          {/* Cart */}
          {!loggedUser ? (
            <div className="mt-1 ml-3"></div>
          ) : (
            <div className="relative">
              <div className="mt-1 ml-3">
                <FaShoppingCart className="text-white w-6 h-6 md:w-4 md:h-4 lg:w-4 lg:h-4 cursor-pointer" onClick={() => handleRoute(APP_ROUTES.CART)} />
              </div>
              {loggedUser.patientId && cartData?.cartItemsCount > 0 && (
                <span className="absolute -top-1.5 -right-2.5 bg-red-500 text-white text-[8px] px-1.5 py-[2px] rounded-full">
                  {cartData?.cartItemsCount > 99 ? "99+" : cartData?.cartItemsCount}
                </span>
              )}
            </div>
          )}

          {/* Desktop hamburger fallback (hidden) */}
          <div className="hidden text-white">
            <button onClick={toggleMobileMenu}>
              {isMobileMenuOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
            </button>
          </div>
        </div>
      </div>

      {/* ══════════════════════════════════════════
          NEW PREMIUM MOBILE SIDE MENU
      ══════════════════════════════════════════ */}

      {/* Overlay */}
      {isMobileMenuOpen && (
        <div className="dox-sidemenu-overlay lg:hidden" onClick={toggleMobileMenu} />
      )}

      {/* Side panel */}
      <div className={`dox-sidemenu lg:hidden ${isMobileMenuOpen ? "open" : ""}`}>

        {/* Header */}
        <div className="dox-sidemenu-header">
          <img className="dox-sidemenu-logo" src={doxzonLogo} alt="Doxzon" />
          <button className="dox-sidemenu-close" onClick={toggleMobileMenu}>
            <FaTimes size={14} />
          </button>
        </div>

        {/* User card (if logged in) */}
        {loggedUser && (
          <div className="dox-sidemenu-usercard">
            <div className="dox-sidemenu-avatar">
              {loggedUser?.firstName?.charAt(0)?.toUpperCase()}
            </div>
            <div>
              <div className="dox-sidemenu-username">{loggedUser?.firstName} {loggedUser?.lastName}</div>
              <div className="dox-sidemenu-subtitle">Patient Account</div>
            </div>
          </div>
        )}

        {/* Scroll area */}
        <div className="dox-sidemenu-scroll">

          {loggedUser ? (
            <>
              {/* Main */}
              <div className="dox-sidemenu-section-label">Main</div>

              <button className={`dox-sidemenu-item ${isActive(APP_ROUTES.HOME) ? "active" : ""}`} onClick={() => handleRoute(APP_ROUTES.HOME)}>
                <span className="dox-sidemenu-item-icon">🏠</span> Home
              </button>
              <button className={`dox-sidemenu-item ${isActive(APP_ROUTES.CONSULTDOCTOR) ? "active" : ""}`} onClick={() => handleRoute(APP_ROUTES.CONSULTDOCTOR)}>
                <span className="dox-sidemenu-item-icon">🩺</span> Consult Doctor
              </button>
              <button className={`dox-sidemenu-item ${isActive(APP_ROUTES.MEDICINES) ? "active" : ""}`} onClick={() => handleRoute(APP_ROUTES.MEDICINES)}>
                <span className="dox-sidemenu-item-icon">💊</span> Medicine
              </button>
              <button className={`dox-sidemenu-item ${isActive(APP_ROUTES.LABTESTS) ? "active" : ""}`} onClick={() => handleRoute(APP_ROUTES.LABTESTS)}>
                <span className="dox-sidemenu-item-icon">🔬</span> Lab Tests
              </button>
              <button className={`dox-sidemenu-item ${isActive(APP_ROUTES.HOSPITALSERVICE) ? "active" : ""}`} onClick={() => handleRoute(APP_ROUTES.HOSPITALSERVICE)}>
                <span className="dox-sidemenu-item-icon">🏥</span> Procedure
              </button>

              <div className="dox-sidemenu-divider" />

              {/* Account */}
              <div className="dox-sidemenu-section-label">Account</div>

              <button className={`dox-sidemenu-item ${isActive(APP_ROUTES.MYPROFILE) ? "active" : ""}`} onClick={() => handleRoute(APP_ROUTES.MYPROFILE)}>
                <span className="dox-sidemenu-item-icon">👤</span> My Profile
              </button>
              <button className={`dox-sidemenu-item ${isActive(APP_ROUTES.MYAPPOINMENTS) ? "active" : ""}`} onClick={() => handleRoute(APP_ROUTES.MYAPPOINMENTS)}>
                <span className="dox-sidemenu-item-icon">📅</span> Appointments
              </button>
              {!loggedUser?.parentPatientId && (
                <button className={`dox-sidemenu-item ${isActive(APP_ROUTES.FAMILYMEMBERS) ? "active" : ""}`} onClick={() => handleRoute(APP_ROUTES.FAMILYMEMBERS)}>
                  <span className="dox-sidemenu-item-icon">👨‍👩‍👧</span> Family Members
                </button>
              )}
              <button className={`dox-sidemenu-item ${isActive(APP_ROUTES.DIETPLAN) ? "active" : ""}`} onClick={() => handleRoute(APP_ROUTES.DIETPLAN)}>
                <span className="dox-sidemenu-item-icon">🥗</span> Diet Plan
              </button>
              <button className={`dox-sidemenu-item ${isActive(APP_ROUTES.MEMBERSHIP) ? "active" : ""}`} onClick={() => handleRoute(APP_ROUTES.MEMBERSHIP)}>
                <span className="dox-sidemenu-item-icon">⭐</span> Membership
              </button>

              <div className="dox-sidemenu-divider" />

              {/* Medical Records — collapsible */}
              <div className="dox-sidemenu-section-label">Medical Records</div>
              <button className="dox-sidemenu-item" onClick={() => setMedRecordsOpen(!medRecordsOpen)}>
                <span className="dox-sidemenu-item-icon">📋</span> Medical Records
                <span className={`dox-chevron ${medRecordsOpen ? "open" : ""}`}>▼</span>
              </button>
              <div className={`dox-sidemenu-submenu ${medRecordsOpen ? "open" : ""}`}>
                <button className="dox-sidemenu-submenu-item" onClick={() => handleRoute(APP_ROUTES.MEDICALHISTORY)}>
                  <span className="dox-sidemenu-submenu-dot" /> Medical History
                </button>
                <button className="dox-sidemenu-submenu-item" onClick={() => handleRoute(APP_ROUTES.MYPRESCRIPTION)}>
                  <span className="dox-sidemenu-submenu-dot" /> My Prescription
                </button>
                <button className="dox-sidemenu-submenu-item" onClick={() => handleRoute(APP_ROUTES.MYREPORTS)}>
                  <span className="dox-sidemenu-submenu-dot" /> My Reports
                </button>
                <button className="dox-sidemenu-submenu-item" onClick={() => handleRoute(APP_ROUTES.MYLABREPORTS)}>
                  <span className="dox-sidemenu-submenu-dot" /> Lab Reports
                </button>
                <button className="dox-sidemenu-submenu-item" onClick={() => handleRoute(APP_ROUTES.MYVITALS)}>
                  <span className="dox-sidemenu-submenu-dot" /> Vitals
                </button>
              </div>

              <div className="dox-sidemenu-divider" />

              {/* More */}
              <div className="dox-sidemenu-section-label">More</div>
              <button className={`dox-sidemenu-item ${isActive(APP_ROUTES.PAYMENTS) ? "active" : ""}`} onClick={() => handleRoute(APP_ROUTES.PAYMENTS)}>
                <span className="dox-sidemenu-item-icon">💳</span> Payments
              </button>
              <button className={`dox-sidemenu-item ${isActive(APP_ROUTES.ORDERHISTORY) ? "active" : ""}`} onClick={() => handleRoute(APP_ROUTES.ORDERHISTORY)}>
                <span className="dox-sidemenu-item-icon">📦</span> Order History
              </button>
              <button className={`dox-sidemenu-item ${isActive(APP_ROUTES.CONSENT) ? "active" : ""}`} onClick={() => handleRoute(APP_ROUTES.CONSENT)}>
                <span className="dox-sidemenu-item-icon">📝</span> Consent
              </button>
              <button className={`dox-sidemenu-item`} onClick={handleEmgDataView}>
                <span className="dox-sidemenu-item-icon">🚨</span> Emergency Data
              </button>
              <button className={`dox-sidemenu-item`} onClick={() => { handleHSNavigation(); setIsMobileMenuOpen(false); }}>
                <span className="dox-sidemenu-item-icon">❤️</span> Health Summary
              </button>
              {loggedUser?.rpmApplicable === "Y" && (
                <button className={`dox-sidemenu-item ${isActive(APP_ROUTES.DEVICES) ? "active" : ""}`} onClick={() => handleRoute(APP_ROUTES.DEVICES)}>
                  <span className="dox-sidemenu-item-icon">📡</span> Devices
                </button>
              )}
              <button className={`dox-sidemenu-item ${isActive(APP_ROUTES.PROCEDURELIST) ? "active" : ""}`} onClick={() => handleRoute(APP_ROUTES.PROCEDURELIST)}>
                <span className="dox-sidemenu-item-icon">🗂️</span> Procedure List
              </button>
              <button className={`dox-sidemenu-item ${isActive(APP_ROUTES.SETTINGS) ? "active" : ""}`} onClick={() => handleRoute(APP_ROUTES.SETTINGS)}>
                <span className="dox-sidemenu-item-icon">⚙️</span> Settings
              </button>

              <div className="dox-sidemenu-divider" />

              {/* Logout */}
              <button className="dox-sidemenu-logout" onClick={handleLogOut}>
                <span style={{ fontSize: 16 }}>🚪</span> Logout
              </button>
            </>
          ) : (
            <>
              {/* Guest menu */}
              <div className="dox-sidemenu-section-label">Explore</div>

              <button className="dox-sidemenu-item" onClick={() => { navigate("/#providers"); setIsMobileMenuOpen(false); }}>
                <span className="dox-sidemenu-item-icon">🏢</span> Dashboard
              </button>
              <button className="dox-sidemenu-item" onClick={() => handleRoute(APP_ROUTES.CONSULTDOCTOR)}>
                <span className="dox-sidemenu-item-icon">🩺</span> Consult Doctor
              </button>
              <button className="dox-sidemenu-item" onClick={() => handleRoute(APP_ROUTES.MEDICINES)}>
                <span className="dox-sidemenu-item-icon">💊</span> Medicine
              </button>
              <button className="dox-sidemenu-item" onClick={() => handleRoute(APP_ROUTES.LABTESTS)}>
                <span className="dox-sidemenu-item-icon">🔬</span> Lab Tests
              </button>
              <button className="dox-sidemenu-item" onClick={() => handleRoute(APP_ROUTES.HOSPITALSERVICE)}>
                <span className="dox-sidemenu-item-icon">🏥</span> Procedure
              </button>

              {/* Footer login/signup for guests */}
              <div className="dox-sidemenu-footer" style={{ marginTop: 24 }}>
                <button className="dox-sidemenu-footer-btn dox-footer-login" onClick={() => { handleLoginModal(); setIsMobileMenuOpen(false); }}>
                  Login
                </button>
                <button className="dox-sidemenu-footer-btn dox-footer-signup" onClick={() => { handleReg(); setIsMobileMenuOpen(false); }}>
                  Sign Up
                </button>
              </div>
            </>
          )}
        </div>

        {/* Bottom footer version tag */}
        <div style={{ padding: "10px 20px", color: "rgba(255,255,255,0.3)", fontSize: 11, textAlign: "center" }}>
          Doxzon · Technology for Health
        </div>
      </div>

      {/* doctor/patient registration */}
      <Modal open={regModal} onCancel={handleRegClose} destroyOnClose footer={[]} width={selectedType === "doctor" ? "60%" : "30%"} style={{ height: "max-content", padding: "0px" }}>
        <SignUp handleRegClose={handleRegClose} />
      </Modal>

      {/* Patient Login */}
      <Modal open={loginModal} footer={[]} className="responsive-modal" onCancel={handleLoginModalClose} destroyOnClose>
        <Login handleLoginModal={handleLoginModalClose} handleSignup={handleSignUpFromLogin} />
      </Modal>

      {/* Emergency data view */}
      <Modal open={emgDataModal} onCancel={handleEmgClose} footer={[]} width={450} destroyOnClose>
        <div><EmergencyDataView /></div>
      </Modal>

      <Drawer closeIcon={false} open={chatOpen} destroyOnClose onClose={handleChatClose}>
        <LiveChat />
      </Drawer>
    </div>
  );
}

export default Navbar;
